import {Injectable, signal, WritableSignal} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class FilterService {
  filterData: WritableSignal<any> = signal(null);
}
